// extracted by mini-css-extract-plugin
export var SubscribeFooter = "SubscribeFooter-module--SubscribeFooter--WUT6e";
export var aniSpin = "SubscribeFooter-module--ani-spin--gDt9T";
export var container = "SubscribeFooter-module--container--brI7U";
export var email = "SubscribeFooter-module--email--JicFJ";
export var emailInput = "SubscribeFooter-module--emailInput--BclJ-";
export var form = "SubscribeFooter-module--form--R0Ecw";
export var heading = "SubscribeFooter-module--heading--GavP9";
export var label = "SubscribeFooter-module--label--cs45-";
export var submit = "SubscribeFooter-module--submit--1qrDf";